export default {
    book: '{product} buchen',
    age_limit: 'Mindestalter {age} Jahre',
    change_plan: 'Plan ändern',
    upgrade_product: 'Produkt aktualisieren',
    upgrade: 'Aktualisierung',
    cancel_upgrade: 'Upgrade abbrechen',
    choose_product: '{product} wählen',
    days: '{count} Tag | {count} Tage',
    login_register: 'Login/Registrieren',
    current: 'Aktuell',
    keyless_benefits: {
        label: 'Straight to car {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Vollversicherung',
            zero_excess: 'kein Überschuss',
            phone_as_a_key: 'Smartphone als Schlüssel',
            straight_to_car: 'Keine Wartezeit',
            no_queues: 'Kein Warten',
            online_id_check: 'Online Identitätsnachweis',
            self_checkout: 'Selbst-Check-out',
        },
    },
};
